export default {
  orderConfirm: {
    Addshippingaddress: 'Add shipping address',
    cannotbedelivered: 'This address cannot be delivered',
    Specifications: 'Specifications',
    Optional: 'Optional',
    Order: 'Order notes',
    Subtotal: 'Subtotal',
    Including: 'Including shipping',
    Total: 'Total',
    Submit: 'Submit order',
    Ordernotes: 'Notes:',
    currently: 'You currently have not created any addresses!'
  }
}
